/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ex_IntroInputs */

const en_viewer_ex_intro = /** @type {(inputs: Viewer_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The paths on the right are what the tree reports for each leaf in the document on the left.`)
};

const ko_viewer_ex_intro = /** @type {(inputs: Viewer_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오른쪽의 경로는 왼쪽 문서의 각 말단에 대해 트리가 보고하는 것입니다.`)
};

const ja_viewer_ex_intro = /** @type {(inputs: Viewer_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右のパスは、左の文書の各末端についてツリーが報告するものです。`)
};

/**
* | output |
* | --- |
* | "The paths on the right are what the tree reports for each leaf in the document on the left." |
*
* @param {Viewer_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ex_intro = /** @type {((inputs?: Viewer_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ex_intro(inputs)
	if (locale === "ko") return ko_viewer_ex_intro(inputs)
	return ja_viewer_ex_intro(inputs)
});